"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

/**
 * Utilities for validating values.
 * @module ValidationUtils
 */
var ValidationUtils = {
  /* eslint-disable quotes, no-useless-escape */

  /**
   * @typedef {String} EMAIL - The email validation regular expression pattern.
   */
  EMAIL: "^(([a-zA-Z0-9!#$%&’*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&’*+/=?^_`{|}~-]+)*)|(\".+\"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$",

  /**
   * @typedef {String} PHONE - The phone validation regular expression pattern.
   */
  PHONE: "^[(]?([0-9]{3})[)]?([-. ])?([0-9]{3})([-. ])?([0-9]{4})$",

  /**
   * @typedef {String} ZIP - The zip validation regular expression pattern.
   */
  ZIP: "^[0-9]{5}(?:-[0-9]{4})?$"
  /* eslint-enable quotes, no-useless-escape */

};
var _default = ValidationUtils;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ValidationUtils, "ValidationUtils", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/validation/validation.js");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/validation/validation.js");
  leaveModule(module);
})();

;